/* eslint-disable no-use-before-define */
import React, { createContext, useState, useContext } from 'react';

const SnackBarContext = createContext({
  open: false,
  message: '',
  variant: 'info',
  show: () => {},
  hide: () => {}
});

export const SnackBarProvider = ({ children }) => {
  const show = (message, variant) => {
    toggleLoading(prevState => ({
      ...prevState,
      open: !prevState.open,
      message,
      variant
    }));
  };

  const hide = () => {
    toggleLoading(prevState => ({
      ...prevState,
      open: !prevState.open
    }));
  };

  const snackBarState = {
    open: false,
    message: '',
    variant: 'info',
    show,
    hide
  };

  const [loading, toggleLoading] = useState(snackBarState);

  return (
    <SnackBarContext.Provider value={loading}>
      {children}
    </SnackBarContext.Provider>
  );
};

export default () => useContext(SnackBarContext);
